import React, { useEffect, useState } from 'react'
import { checkActiveFilter, checkAnyActiveFilters, toggleSorting } from '../helpers/updateURLParams'
import { Option } from '../../search-spring/types/types'

type Props = {
  sortingOrder: Option
  activeSort: string
  setActiveSort: React.Dispatch<React.SetStateAction<string>>
}

const DesktopSortingItem = ({sortingOrder, activeSort, setActiveSort}: Props) => {

  // Need to check whether it is present or not in the url to determine if active or not. 
  const [sortActive, setSortActive] = useState(false)

  const handleFilterClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (activeSort == "ga_unique_purchases" && e.currentTarget.dataset.field == "ga_unique_purchases") {
      // bestselling filter is active by default and they are trying to unselect it 
      return
    }
    toggleSorting(e)
    const sortStatus = checkActiveFilter(sortingOrder.field, sortingOrder.direction)
    setActiveSort(sortingOrder.field + sortingOrder.direction)
    setSortActive(sortStatus)
  }

  useEffect(() => {
    // Checks on load if the filter is in thr url and if it is set our state. 
    const sortStatus = checkActiveFilter(sortingOrder.field, sortingOrder.direction)
    setSortActive(sortStatus)
  },[activeSort])

  // Setting a default sort order.
  useEffect(() => {
    if (sortingOrder.field == "ga_unique_purchases" && checkAnyActiveFilters() == false) {
      setSortActive(true)
    }
  }, [])
  
  return (
    <a data-field={sortingOrder.field} data-value={sortingOrder.direction} onClick={(e) => handleFilterClick(e)} className={`block py-2XS uppercase cursor-pointer font-calibre text-sm-b no-underline flex items-center justify-end gap-1 ${sortActive ? 'text-black' : 'text-subdued'}`}>
      {sortActive &&
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 10 8" fill="black">
          <circle cx="4" cy="4" r="4" fill="black"/>
        </svg>
      }
      {sortingOrder.label}
    </a>
  )
}

export default DesktopSortingItem